import type { ComponentType } from 'react';
import { FaGithub } from 'react-icons/fa';

import { ModalCloseButton } from '../components/InfoModals';

type AccountIconComponent = ComponentType<{ 'aria-hidden'?: boolean }>;

// Filled Invertocat mark, per GitHub's logo guidelines for sign-in buttons.
const IconGithubMark = FaGithub as unknown as AccountIconComponent;

type GitHubAccountState = 'idle' | 'loading' | 'ready' | 'error';

interface RunGitHubLoginModalProps {
  isOpen: boolean;
  configState: GitHubAccountState;
  isConfigured: boolean;
  onCloseLoginPrompt: () => void;
  onLogin: () => void;
}

export function RunGitHubLoginModal({
  isOpen,
  configState,
  isConfigured,
  onCloseLoginPrompt,
  onLogin
}: RunGitHubLoginModalProps) {
  const isLoginDisabled = configState === 'loading' || !isConfigured;

  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal-overlay" onClick={onCloseLoginPrompt}>
      <div
        className="modal-content run-login-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="run-login-title"
        aria-describedby="run-login-subtitle"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="run-login-close">
          <ModalCloseButton onClose={onCloseLoginPrompt} />
        </div>

        <div className="run-login-body">
          <img className="run-login-logo" src="/logoinvert.png" alt="" aria-hidden={true} />
          <h2 id="run-login-title">Log in to Havu</h2>

          <button
            type="button"
            className="run-login-github"
            onClick={onLogin}
            disabled={isLoginDisabled}
          >
            <IconGithubMark aria-hidden={true} />
            <span>{configState === 'loading' ? 'Loading...' : 'Log in with GitHub'}</span>
          </button>

          <p id="run-login-subtitle" className="run-login-footnote">
            By continuing, you agree to Havu&apos;s Terms of Service and Privacy Policy.
          </p>
        </div>
      </div>
    </div>
  );
}
